// IMPORTS
import baseIcon from "./baseIcon"

/**
 * Exporting "default" so that the import doesn't have to be named in other components.
 * To create named and/or multiple exports, use: export cont compName = {}
 * Remember to import any reactive features from 'vue' if you need reactivity (e.g. computed, ref, reactive, etc.)
 */
export default {
    /* Name the component for easy reference */
    name: 'IconMagnifyingGlass',

    /* Any imported component for this file needs to be listed here */
    components: {
        baseIcon
    },

    /* Declare any expected props here */
    props: {
        fill: {
            type: String,
            required: false,
            default: '#FFFFFF'
        }
    },

    /* All component logic goes here in setup(). Anything complex or verbose should be handled in an external file,
        using this as more of a "controller" for the component.
    */
    setup(props) {
        

        /* We need to return any variables/functions that we want to use in our template below. */
        return {
            props
        }
    },

    /* Define the template that will be displayed for this component (optional) */
    template: /*html*/`
        <div class="cfm_ec_icon cfm_ec_icon_magnifying_glass">

            <base-icon
            :fill="props.fill"
            d="M13 8h-8v-1h8v1zm0 2h-8v-1h8v1zm-3 2h-5v-1h5v1zm11.172 12l-7.387-7.387c-1.388.874-3.024 1.387-4.785 1.387-4.971 0-9-4.029-9-9s4.029-9 9-9 9 4.029 9 9c0 1.761-.514 3.398-1.387 4.785l7.387 7.387-2.828 2.828zm-12.172-8c3.859 0 7-3.14 7-7s-3.141-7-7-7-7 3.14-7 7 3.141 7 7 7z"
            ></base-icon>

        </div>
    `,
}